import { render, staticRenderFns } from "./r-map-addon-group-dialog.vue?vue&type=template&id=0011baba&scoped=true"
import script from "./r-map-addon-group-dialog.vue?vue&type=script&lang=js"
export * from "./r-map-addon-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-map-addon-group-dialog.vue?vue&type=style&index=0&id=0011baba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0011baba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0011baba')) {
      api.createRecord('0011baba', component.options)
    } else {
      api.reload('0011baba', component.options)
    }
    module.hot.accept("./r-map-addon-group-dialog.vue?vue&type=template&id=0011baba&scoped=true", function () {
      api.rerender('0011baba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-addon/group/r-map-addon-group-dialog.vue"
export default component.exports